import { SIZE } from 'baseui/button'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'

import { ActionsRow, TypesRow } from '../styled-components'
import useAddModal from './useAddModal'

interface AddModalProps {
  isOpen: boolean
  close: () => void
}

interface SDSelectParams {
  value: { id: string; label: string }[]
}

const AddModal = ({ isOpen, close }: AddModalProps) => {
  const {
    t,
    name,
    siteId,
    types,
    availableTypes,
    countrySites,
    formErrors,
    setName,
    selectSite,
    toggleType,
    submitHandler,
  } = useAddModal({ isOpen, close })

  const siteOptions = countrySites.reduce<Record<string, string>>((options, site) => {
    options[String(site.id)] = t(`suppliersManagement:business_verticals.${site.business_type}`, site.business_type)
    return options
  }, {})

  return (
    <form onSubmit={submitHandler}>
      <SDFormControl error={formErrors.site_id ? formErrors.site_id[0] : ''}>
        {/* @ts-expect-error SDSelect is a JS component */}
        <SDSelect
          label={t('suppliersManagement:modal.business_vertical')}
          optionsList={siteOptions}
          placeholder={t('common:choose')}
          selectedValue={siteId}
          hasError={!!formErrors.site_id}
          onChangeHandler={(params: SDSelectParams) => selectSite(params.value[0]?.id ?? '')}
        />
      </SDFormControl>

      <SDFormControl error={formErrors.name ? formErrors.name[0] : ''}>
        {/* @ts-expect-error SDInput is a JS component */}
        <SDInput
          id='supplier-name'
          label={t('suppliersManagement:modal.name')}
          currentValue={name}
          error={!!formErrors.name}
          outerOnchange={(value: string | null) => setName(value ?? '')}
        />
      </SDFormControl>

      <SDFormControl
        label={t('suppliersManagement:modal.types')}
        caption={t('suppliersManagement:modal.types_caption')}
        error={formErrors.types ? formErrors.types[0] : ''}
      >
        <TypesRow>
          {availableTypes.map(type => (
            // @ts-expect-error SDCheckbox is a JS component
            <SDCheckbox
              key={type}
              label={t(`suppliersManagement:types.${type}`, type)}
              checked={types.includes(type)}
              onChange={() => toggleType(type)}
            />
          ))}
        </TypesRow>
      </SDFormControl>

      <ActionsRow>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton size={SIZE.compact} block={false} type='submit' disabled={!name || !siteId || !types.length}>
          {t('common:create')}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton size={SIZE.compact} block={false} type='button' onClick={close}>
          {t('common:cancel')}
        </SDButton>
      </ActionsRow>
    </form>
  )
}

export default AddModal
